export default "/v11.0.0/3246a77/bundles/manifest.json";